export default {"src":"/_next/static/media/landing-page-background-down.061494dd.svg","height":3425,"width":607};